
import React from 'react';

const galleryItems = [
  { name: 'Ananya Kapoor', size: '34-28-36', imageUrl: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSacDw1S6rrnwZgVkb4TZCKQy8oOunBVjl6HvIlwd26ycBAoJ-h6YhFj0ZA&s=10', badge: null },
  { name: 'Simran Kaur', size: '32-30-36', imageUrl: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQwsobq42ZZ3eSRWHa10D3WQQB9WCjl7oVb_6VIz-JGuA1vN7KqsuBJfv-B&s=10', badge: null },
  { name: 'Kavya Mehta', size: '36-32-42', imageUrl: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSuEV7C1_056aS3P9JkV_h1EqP2bdBj9lPBZ4lGhipsq-7KKaFFAGnEWR8&s=10', badge: null },
  { name: 'Ishita Verma', size: '32-30-34', imageUrl: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQGiWw_6QJUYaEvDBaMX26fUvOjYTH8yMbu8Pq_ggzXnhrW733d6LgUhFk&s=10', badge: null },
  { name: 'Sana Sheikh', size: '32-26-30', imageUrl: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRtg59VWTv8GjezVdE5gFYBGD6jFE9NzP5VHnCBSgkI6qUFtPO3IDlReQV4&s=10', badge: 'VIP' },
  { name: 'Priyanka Roy', size: '30-28-29', imageUrl: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTgsIQH09l0XndeVeDuAIsj81V-bWO6kiM-vkfZH-D38LidErZTMX0tvO4L&s=10', badge: 'HOT' },
  { name: 'Alisha Khan', size: '30-28-32', imageUrl: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR5lZv1kDkNCJqfSQ5VWrNnuqV3nXEc1h-4GbIZk8WAzQ&s', badge: 'VIP' },
  { name: 'Nikita Singh', size: '30-32-29', imageUrl: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSzWWoEJFIctp7yKSqjsDOnKYJTtt8BpzjC0oi7lGxDnw&s', badge: 'HOT' },
  { name: 'Riya Sharma', size: '34-26-34', imageUrl: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcReJ3HAzUMZFQrZMhFNXISyRgR3WNpPYdIwqFiBCbZxO2CwU72jxohCBsMQ&s=10', badge: null },
  { name: 'Pooja Gupta', size: '32-28-32', imageUrl: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSTzxb2UtV-2_uFfXuCYytfsxgfAKk6uAD4Il8eclzd5Q&s=10', badge: null },
  { name: 'Neha Verma', size: '36-30-38', imageUrl: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSCDCKKGFYGSFJJODA9TCyGwOxafnvieHutvlCyIgSDf4pKFlpUJiIUZvQ&s=10', badge: 'VIP' },
  { name: 'Anjali Singh', size: '34-28-35', imageUrl: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSYPBhOxVq4exuJnbpgiFtQRAYoRsckrzkjfwILTf7AJwME7kzZjjsve9CQ&s=10', badge: 'HOT' },
];

const Gallery = () => {
  return (
    <section id="gallery" className="py-20 bg-[#210002]">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-extrabold text-white mb-4">yourcallgirl.com</h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
          {galleryItems.map((item, index) => (
            <div key={index} className="bg-[#3F0101] rounded-lg overflow-hidden shadow-lg">
              <div className="relative">
                <img className="w-full h-80 object-cover" src={item.imageUrl} alt={item.name} />
                <div className="absolute inset-0 bg-black bg-opacity-20 flex items-center justify-center">
                  <span className="text-white text-lg font-bold">yourcallgirl.com</span>
                </div>
                {item.badge && (
                  <span className={`absolute top-2 right-2 text-white text-xs font-bold px-2 py-1 rounded ${item.badge === 'VIP' ? 'bg-yellow-500' : 'bg-red-500'}`}>
                    {item.badge}
                  </span>
                )}
              </div>
              <div className="p-4 text-white">
                <h3 className="text-xl font-bold">{item.name}</h3>
                <p className="text-sm text-gray-300">Size: {item.size}</p>
                <div className="flex justify-center mt-4">
                  <a href="https://wa.me/917838380756" target="_blank" rel="noopener noreferrer" className="bg-green-500 text-white font-bold py-2 px-4 rounded-full w-5/12 text-center">
                    WhatsApp
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
